export const clearProducts = () => {
  return {
    type: 'CLEAR_PRODUCTS',
    products: []
  }
}

export const loadProducts = (products) => {
  let availableProducts = products;
  if(products[0].node != undefined) {
    availableProducts = products.filter(product => product.node.availableForSale);
  }
  return {
    type: 'LOAD_PRODUCTS',
    products: availableProducts
  }
}
